var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62069 19.6208C14.934 19.6208 19.2414 15.3134 19.2414 10.0001C19.2414 4.68672 14.934 0.379395 9.62069 0.379395C4.30733 0.379395 0 4.68672 0 10.0001C0 15.3134 4.30733 19.6208 9.62069 19.6208Z",
    fill: "#EE0005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3793 19.6208C26.6927 19.6208 31 15.3134 31 10.0001C31 4.68672 26.6927 0.379395 21.3793 0.379395C16.0659 0.379395 11.7586 4.68672 11.7586 10.0001C11.7586 15.3134 16.0659 19.6208 21.3793 19.6208Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 2.38367C13.2241 4.14319 11.7586 6.90018 11.7586 9.99946C11.7586 13.0987 13.2241 15.8557 15.5 17.6153C17.7758 15.8557 19.2414 13.0987 19.2414 9.99946C19.2414 6.90018 17.7758 4.14319 15.5 2.38367Z",
    fill: "#FF6300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.dc30f80c248d696fa95758af48433007.svg";
export { ForwardRef as ReactComponent };